"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _Card = _interopRequireDefault(require("@p24/icons/Card"));

var _Visa = _interopRequireDefault(require("@p24/icons/Visa"));

var _Mastercard = _interopRequireDefault(require("@p24/icons/Mastercard"));

function _default() {
  return {
    width: 'auto',
    minWidth: 'auto',
    position: 'relative',
    appearanceMC: _Mastercard["default"],
    appearanceVisa: _Visa["default"],
    appearanceCard: _Card["default"]
  };
}